<template>
  <div class="f-count-down">
    <div v-if="type === 'cn'">
      <span v-if="count > 86400">{{ days }}</span>
      <span v-if="count > 86400" class="font-sm"> 天 </span>
      <span v-if="count > 3600">{{ hours | twoDigits }}</span>
      <span v-if="count > 3600" class="font-sm"> 小时 </span>
      <span v-if="count > 60">{{ minutes | twoDigits }}</span>
      <span v-if="count > 60" class="font-sm"> 分 </span>
      <span v-if="count > 0">{{ seconds | twoDigits }}</span>
      <span v-if="count > 0" class="font-sm"> 秒</span>
    </div>
    <div v-if="type === 'time'">
      <span v-if="count > 86400">{{ days }}</span>
      <span v-if="count > 86400" style="margin-right: 10px;">天</span>
      <span v-if="!endtextShow">{{ hours | twoDigits }}：{{ minutes | twoDigits }}：{{ seconds | twoDigits }}</span>
    </div>
    <div v-if="endtextShow">{{ endtext }}</div>
  </div>
</template>

<script>
export default {
  name: 'FCountDown',
  filters: {
    twoDigits(value) {
      if (value.toString().length <= 1) {
        return '0' + value.toString()
      }
      return value.toString()
    }
  },
  props: {
    // 截止日期时间戳，秒
    endtimestamp: {
      type: Number,
      default: 0
    },
    // 截止日期字符串，如 '2020-01-01 12:00:00'
    endtime: {
      type: String,
      default: ''
    },
    // 倒计时长，单位秒
    diff: {
      type: Number,
      default: 0
    },
    // 类型，cn=中文风格，time=时钟风格
    type: {
      type: String,
      default: 'cn'
    },
    // 到期后显示的文本
    endtext: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      interval: null,
      now: Math.trunc((new Date()).getTime() / 1000),
      deadline: null,
      count: 0,
      endtextShow: false
    }
  },
  computed: {
    seconds() {
      return Math.trunc(this.count) % 60
    },
    minutes() {
      return Math.trunc(this.count / 60) % 60
    },
    hours() {
      return Math.trunc(this.count / 60 / 60) % 24
    },
    days() {
      return Math.trunc(this.count / 60 / 60 / 24)
    }
  },
  watch: {
    now(value) {
      this.count = this.deadline - value
      if (this.count <= 0) {
        this.count = 0
        clearInterval(this.interval)
        this.$emit('finish')
        if (this.endtext) {
          this.endtextShow = true
        }
      }
    }
  },
  created() {
    // 优先级：结束时间戳 > 结束时间字符串 > 倒计时长
    if (this.endtimestamp) {
      this.deadline = this.endtimestamp
    } else if (this.endtime) {
      this.deadline = Math.trunc(Date.parse(this.endtime.replace(/-/g, '/')) / 1000)
    } else if (this.diff) {
      this.deadline = this.now + this.diff
    } else {
      throw new Error('传入截止日期错误')
    }
    this.interval = setInterval(() => {
      this.now = Math.trunc((new Date()).getTime() / 1000)
    }, 1000)
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  methods: {
  }
}
</script>

<style lang="scss" slot-scoped>
.f-count-down {
  display: inline-block;
}
</style>
